import { render, staticRenderFns } from "./updatePasswordDialog.vue?vue&type=template&id=39d880a8&scoped=true"
import script from "./updatePasswordDialog.vue?vue&type=script&lang=js"
export * from "./updatePasswordDialog.vue?vue&type=script&lang=js"
import style0 from "./updatePasswordDialog.vue?vue&type=style&index=0&id=39d880a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d880a8",
  null
  
)

export default component.exports